// @flow

/**
 * Module dependencies.
 */

import { branch } from 'core/utils';
import { colors, keyframes, units } from 'client/styles';
import { compose, defaultProps } from 'recompose';
import { position, size } from 'polished';
import Icon from 'client/components/core/icon';
import React from 'react';
import styled from 'styled-components';

/**
 * Variables constants.
 */

const spinAnimation = `${keyframes.spin} .8s infinite linear`;

/**
 * `Props` type.
 */

type Props = {
  isLoading: boolean,
  themeColor: string
};

/**
 * `LoaderWrapper` component.
 */

const LoaderWrapper = styled.span`
  ${position('absolute', '-26px', '0', null, '50%')};
  ${size(units(7), units(7))};

  background-color: ${({ color }) => color};
  border-radius: ${units(3.5)};
  color: ${colors.white};
  margin-left: -${units(3.5)};
  z-index: 10;

  ${({ loading }) => branch(loading, `animation: ${spinAnimation};`)}

  > span {
    ${position('absolute', '50%', null, null, '50%')}

    transform: translate(-50%, -50%);
  }
`;

/**
 * `Loader` component.
 */

function Loader(props: Props): React$Element<*> {
  const { isLoading, themeColor } = props;

  return (
    <LoaderWrapper
      color={themeColor}
      loading={isLoading}
    >
      <Icon
        icon={'swap'}
        size={units(4)}
      />
    </LoaderWrapper>
  );
}

/**
 * Export `Loader`.
 */

export default compose(
  defaultProps({
    isLoading: false,
    themeColor: colors.brandPrimary
  }),
)(Loader);



// WEBPACK FOOTER //
// ../src/client/components/forms/components/loader.js